import { ADD_SUBCATEGORY, EDIT_SUBCATEGORY, GET_SUBCATEGORIES_LIST } from './ApiConstants';
import api from './ApiHandler';

export const getSubCategoriesByPage = async ({
  page,
  limit,
  categoryId
}: {
  page: number;
  limit: number;
  categoryId: string;
}) => {
  return await api.get(GET_SUBCATEGORIES_LIST, {
    params: { page, limit, categoryId }
  });
};

export const createSubCategory = async (payload: any) => {
  return await api.post(ADD_SUBCATEGORY, { ...payload });
};

export const editSubCategory = async (payload: any) => {
  return await api.post(EDIT_SUBCATEGORY, { ...payload });
};
